<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<div class="row">
  <div class="col-12 col-md-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="javascript:void(0);">
            <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </a>
        </li>
        <li class="breadcrumb-item">
          <a [routerLink]="'/private/affiliate'" translate>Affiliate Marketing</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page" translate>Affiliate Marketing Invoices</li>
      </ol>
    </nav>
  </div>
</div>
<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">
    <div class="table-responsive mb-4 mt-4">
      <table id="multi-column-ordering" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <th translate>ID</th>
          <th translate>Invoice Number</th>
          <th translate>Merchant Email</th>
          <th translate>Merchant Name</th>
          <th translate>Merchant Phone</th>
          <th translate>Order Number</th>
          <th translate>Amount</th>
          <th translate>Date</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="invoices == null || invoices.length == 0">
          <td colspan="11" style="text-align: center; font-size: 12pt; color: cadetblue">
            {{ 'No invoices have been created by any merchant' | translate }}
          </td>
        </tr>
        <tr *ngFor="let invoice of invoices">
          <!-- ID -->
          <td>
            <span>{{ invoice.id }}</span>
          </td>
          <!-- Invoice Number -->
          <td>
            <span>{{ invoice.invoiceNumber }}</span>
          </td>
          <!-- Merchant Email -->
          <td>
            <span>{{ invoice.merchantEmail }}</span>
          </td>
          <!-- Merchant Name -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{ invoice.merchantFirstName }} {{ invoice.merchantLastName }}</p>
          </td>
          <!-- Merchant Phone -->
          <td>
            <span>{{ invoice.merchantPhone }}</span>
          </td>
          <!-- Order Number -->
          <td>
            <span>{{ invoice.orderOrderNumber }}</span>
          </td>
          <!-- Amount -->
          <td>
            <span>{{ invoice.amount }}</span>
          </td>
          <!-- Transfer Date -->
          <td>
            <!--format the date to YYYY/MM/DD -->
            <span>{{ invoice.transferDate | date :'y/M/d' }}</span>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th translate>Invoice Number</th>
          <th translate>Merchant Email</th>
          <th translate>Merchant Name</th>
          <th translate>Merchant Phone</th>
          <th translate>Order Number</th>
          <th translate>Amount</th>
          <th translate>Date</th>
        </tr>
        </tfoot>
      </table>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-between mt-4" *ngIf="totalPages > 1">
        <div>
          <span translate>Showing</span> {{ currentPage * 20 + 1 }} - {{ (currentPage + 1) * 20 > totalItems ? totalItems : (currentPage + 1) * 20 }} <span translate>of</span> {{ totalItems }} <span translate>entries</span>
        </div>
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item" [class.disabled]="currentPage === 0">
              <a class="page-link" href="javascript:void(0);" (click)="loadData(0)" aria-label="First">
                <span aria-hidden="true">&laquo;&laquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === 0">
              <a class="page-link" href="javascript:void(0);" (click)="loadData(currentPage - 1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li class="page-item" *ngFor="let page of [].constructor(totalPages > 5 ? 5 : totalPages); let i = index"
                [class.active]="currentPage === i">
              <a class="page-link" href="javascript:void(0);" (click)="loadData(i)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
              <a class="page-link" href="javascript:void(0);" (click)="loadData(currentPage + 1)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
              <a class="page-link" href="javascript:void(0);" (click)="loadData(totalPages - 1)" aria-label="Last">
                <span aria-hidden="true">&raquo;&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </div>
    <div class="row mb-4">
      <div class="col-12">
        <button class="btn btn-primary" [routerLink]="'/private/affiliate'" translate>Back</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
